import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';
import { environment } from '@environments/environment';
import { ToasterService } from '@app/shared/services/toaster.service';
import { ToastTitle } from '@app/shared/constants/global.enum';

export interface PeopleMetricsResponse {
  status: string;
  reason: string;
  data: {
    totalNumberOfOpenPositions: number;
    nicheSkillsCandidatesCount: number;
    averageSpeedOfClosure: number;
    countOfVoluntaryAttrition: number;
    countOfInvoluntaryAttrition: number;
    bufferResourcesCount: number;
    numberOfFullTimeConversions: number;
  };
}

export interface SkillsDistributionResponse {
  status: string;
  reason: string;
  data: {
    skillName: string;
    employeeCount: number;
  }[];
}

@Injectable({
  providedIn: 'root',
})
export class PeopleMetricsService {
  private baseUrl = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private toasterService: ToasterService,
  ) {}

  getPeopleMetrics(
  vendorId: string,
  quarter: string,
  year: string,
  employeeId?: string,
): Observable<PeopleMetricsResponse> {
  const url = `${this.baseUrl}/hiring/quarterly-feedback/people-metrics`;

  let params = new HttpParams()
    .set('vendorId', vendorId)
    .set('quarter', quarter)
    .set('year', year);

  if (employeeId) {
    params = params.set('employeeId', employeeId);
  }

  return this.http.get<PeopleMetricsResponse>(url, { params }).pipe(
    catchError((error) => {
      const message = error.error?.message || 'An unexpected error occurred';
      this.toasterService.showError(message, ToastTitle.ERROR);
      return throwError(() => error);
    }),
  );
}


  getSkillsDistribution(
    quarter: string,
    year: string,
  ): Observable<SkillsDistributionResponse> {
    const url = `${this.baseUrl}/vendor/skill-distribution`;
    return this.http.get<SkillsDistributionResponse>(url).pipe(
      catchError((error) => {
        this.toasterService.showError(error.error?.message, ToastTitle.ERROR);
        return throwError(() => error);
      }),
    );
  }
}
